import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_isomorphic_dompurify_432bd6d7__ from "isomorphic-dompurify";
function ExternalHtml({ rawHtml, ...restProps }) {
    const sanitizedHtml = __WEBPACK_EXTERNAL_MODULE_isomorphic_dompurify_432bd6d7__["default"].sanitize(rawHtml);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        ...restProps,
        dangerouslySetInnerHTML: {
            __html: sanitizedHtml
        }
    });
}
export { ExternalHtml as default };

//# sourceMappingURL=ExternalHtml.js.map